// Russian for the `views` namespace (spec 16 §4) — the saved-views switcher
// on the sales books and the work-order list. Its readers are the KazKabel
// sales managers and planners, who already work those lists in Russian.
//
// REGISTER. «Представление» for a saved view, the word Russian business
// software uses for a named arrangement of a list; «список» for the screen it
// belongs to; «общее» and «личное» for shared and private. «Столбцы», not
// «колонки», for the table's columns, as the rest of the office area says.

export const viewsRu = {
  switcher: {
    label: "Сохранённые представления",
    all: "Все",
    moreViews: "Ещё представления",
    modified: "Изменено",
    empty: "Сохранённых представлений пока нет",
    loading: "Загрузка сохранённых представлений",
  },
  shared: "Общие",
  tools: {
    columns: "Столбцы",
    columnsUnavailable: "Столбцы можно выбрать, когда в списке появятся строки.",
    save: "Сохранить",
    saving: "Сохранение…",
    saveAsNew: "Сохранить как новое",
    reset: "Сбросить",
    manage: "Управление",
  },
  notice: {
    stale: "Некоторые фильтры этого представления больше не действуют",
    gone: "Этого представления больше нет",
  },
  error: {
    read: "Не удалось загрузить сохранённые представления.",
    readNamed:
      "Не удалось загрузить сохранённые представления, поэтому представление из этой ссылки не применено.",
    offline: "Нет сети, поэтому сохранённые представления не загрузились.",
    offlineNamed: "Нет сети, поэтому представление из этой ссылки не применено.",
    retry: "Повторить",
    retrying: "Повторная попытка…",
    requestId: "Идентификатор запроса",
  },
  saveNew: {
    title: "Сохранить как новое представление",
    name: "Название",
    share: "Открыть доступ всем, кто может открыть этот список",
    submit: "Сохранить представление",
    submitting: "Сохранение…",
    cancel: "Отмена",
    openManage: "Открыть управление",
  },
  errors: {
    nameRequired: "Укажите название представления.",
    nameTooLong: "Название не может быть длиннее 60 символов.",
    nameInvalid: "Название содержит символ, который нельзя сохранить.",
    nameTaken: "Представление с таким названием в этом списке уже есть.",
    limitMember:
      "У вас уже {{limit}} представлений в этом списке. Удалите одно в разделе «Управление», чтобы сохранить новое.",
    limitShared:
      "В этом списке уже {{limit}} общих представлений. Удалите одно в разделе «Управление» или сохраните это представление без общего доступа.",
    systemImmutable: "Встроенное представление нельзя изменить или удалить.",
    notOwner: "Изменить это представление может только тот, кто его сохранил.",
    notFound: "Этого представления больше нет.",
    readOnly: "Сеанс открыт только для чтения, поэтому представления изменить нельзя.",
    forbidden: "С вашим доступом нельзя сохранять представления в этом списке.",
    failed: "Не удалось сохранить изменения.",
    filterInvalid:
      "Фильтр «{{filter}}» содержит значение, которое нельзя сохранить. Измените или очистите его и сохраните снова.",
    offline: "Нет сети, поэтому изменение не сохранено. Повторите, когда сеть вернётся.",
    mayHaveSaved:
      "Связь прервалась до ответа, поэтому изменение могло сохраниться. Повторите, и оно не сохранится дважды.",
    earlierTryLanded:
      "Более ранняя попытка этого изменения прошла, и список уже её показывает. Проверьте список, прежде чем повторять.",
  },
  filters: {
    status: "Статус",
    facility_id: "Площадка",
    work_center_id: "Рабочий центр",
    product_id: "Продукт",
    due_after: "Срок с",
    due_before: "Срок по",
    overdue: "Только просроченные",
    q: "Поиск",
    tier: "Ценовая категория",
    owner: "Ответственный",
    credit_hold: "Кредитный стоп",
    customer: "Клиент",
    origin: "Источник",
    off_list: "Только строки вне прайса",
    created_from: "Создано с",
    created_to: "Создано по",
    facility: "Площадка",
    stage: "Этап",
    close_from: "Закрытие с",
    close_to: "Закрытие по",
    rotting: "Только зависшие",
    needs_next_step: "Нужен следующий шаг",
    tag: "Метка",
    lost_reason: "Причина проигрыша",
    scope: "Чьи задачи",
    due: "Срок",
    assignee: "Исполнитель",
  },
  validation: {
    contact_address_not_shareable:
      "Общее представление не может хранить в поиске телефон, чат или почту. Очистите поиск или оставьте представление личным.",
  },
  manage: {
    title: "Управление представлениями",
    close: "Закрыть",
    private: "Личное",
    isShared: "Общее",
    rename: "Переименовать",
    renameLabel: "Новое название для «{{name}}»",
    renameSave: "Сохранить название",
    cancel: "Отмена",
    share: "Открыть доступ",
    unshare: "Закрыть доступ",
    delete: "Удалить",
    deleteConfirm: "Удалить «{{name}}»? Это действие нельзя отменить.",
    deleteYes: "Удалить представление",
    working: "Сохранение…",
  },
  more: {
    title: "Применить представление",
    close: "Закрыть",
    applied: "Применено",
  },
  columns: {
    title: "Столбцы",
    close: "Закрыть",
    done: "Готово",
    fixed: "Закреплён",
    resetWidths: "Сбросить ширину",
    moveUp: "Переместить «{{column}}» выше",
    moveDown: "Переместить «{{column}}» ниже",
    resize: "Изменить ширину столбца «{{column}}»",
  },
  region: {
    loading: "Загрузка списка",
  },
} as const;
